const skills = [
    {
        title: "Mechanical & Robotics",
        items: [
            "Mechanical Design & CAD",
            "Mechatronics & System Integration",
            "Aeromodeling & RC Vehicles",
        ]
    },
    {
        title: "Software & Web Development",
        items: [
            "Python & C/C++",
            "React & Next.js",
            "Django & FastAPI",
            "REST APIs & Database Design"
        ]
    }
];

export default skills;